import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationEditorComponent } from './validation-editor.component';

import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { InputTextModule } from 'primeng/inputtext';



import { EditValidationColumnDialogComponent } from './pages/editValidationColumn.dialog.component';
import { EditValidationListDialogComponent } from './pages/editValidationList.dialog.component';
import { EditAvailableColumnDialogComponent } from './pages/editAvailableColumn.dialog.component';
import { NgStringPipesModule } from 'ngx-pipes';
import { TooltipModule } from 'primeng/tooltip';
import { MatIconModule } from '@angular/material/icon';

import { MessageModule } from 'primeng/message';

import { InputNumberModule } from 'primeng/inputnumber';
import { CommonDataModule, CommonDataService } from 'FoxxyLib';
import { DatePickerModule } from 'primeng/datepicker';
import { TextareaModule } from 'primeng/textarea';
import { MultiSelectModule } from 'primeng/multiselect';

@NgModule({
    imports: [
        CommonModule,

        CommonDataModule,
        ToolbarModule,
        ButtonModule,
        TableModule,
        MultiSelectModule,
        CheckboxModule,
        FormsModule,
        ConfirmDialogModule,
        InputNumberModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        DatePickerModule,
        NgStringPipesModule,
        MessageModule,
        TooltipModule, MatIconModule
    ],
    exports: [ValidationEditorComponent, EditValidationColumnDialogComponent, EditValidationListDialogComponent, EditAvailableColumnDialogComponent],
    declarations: [ValidationEditorComponent, EditValidationColumnDialogComponent, EditValidationListDialogComponent, EditAvailableColumnDialogComponent],
    providers: [ CommonDataService ]
})

export class ValidationEditorModule { }

